var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.25C1.75 3.60008 1.75 2.77513 2.26256 2.26256C2.77513 1.75 3.60008 1.75 5.25 1.75C6.8999 1.75 7.72485 1.75 8.23742 2.26256C8.75 2.77513 8.75 3.60008 8.75 5.25C8.75 6.8999 8.75 7.72485 8.23742 8.23742C7.72485 8.75 6.8999 8.75 5.25 8.75C3.60008 8.75 2.77513 8.75 2.26256 8.23742C1.75 7.72485 1.75 6.8999 1.75 5.25Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.75C5.25 10.3999 5.25 11.2248 5.76256 11.7374C6.27515 12.25 7.1001 12.25 8.75 12.25C10.3999 12.25 11.2248 12.25 11.7374 11.7374C12.25 11.2248 12.25 10.3999 12.25 8.75C12.25 7.1001 12.25 6.27515 11.7374 5.76256C11.2248 5.25 10.3999 5.25 8.75 5.25",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.d65341fffc52b58411ba646adc46fde4.svg";
export { ForwardRef as ReactComponent };